import { useState, useRef, useEffect } from 'react';

export const useScrollObserver = <T extends HTMLElement>() => {
	const [canScrollLeft, setCanScrollLeft] = useState(false);
	const [canScrollRight, setCanScrollRight] = useState(false);
	const containerRef = useRef<T>(null);

	const checkScroll = () => {
		const element = containerRef.current;

		if (element) {
			setCanScrollLeft(element.scrollLeft > 0);
			setCanScrollRight(element.scrollLeft < element.scrollWidth - element.clientWidth - 1);
		}
	};

	useEffect(() => {
		const element = containerRef.current;
		if (element) {
			checkScroll();
			element.addEventListener('scroll', checkScroll);
			window.addEventListener('resize', checkScroll);

			// Initial check after content loads
			const initialCheck = setTimeout(checkScroll, 100);

			return () => {
				element.removeEventListener('scroll', checkScroll);
				window.removeEventListener('resize', checkScroll);
				clearTimeout(initialCheck);
			};
		}
	}, []);

	const scrollLeft = () => {
		const element = containerRef.current;
		if (element) {
			element.scrollBy({ left: -240, behavior: 'smooth' });
		}
	};

	const scrollRight = () => {
		const element = containerRef.current;
		if (element) {
			element.scrollBy({ left: 240, behavior: 'smooth' });
		}
	};

	return {
		containerRef,
		canScrollLeft,
		canScrollRight,
		scrollLeft,
		scrollRight
	};
};
